import { BoxShadowLayout } from "layouts";
import { SharingSocials } from "modules/sharing";
import { useTranslation } from "react-i18next";

import { useSocialSources } from "../../api";
import { SocialItem } from "./atoms";

import styles from "./SocialSources.module.scss";

const SocialSources = () => {
  const { socialSources } = useSocialSources();

  const { t } = useTranslation();

  return (
    <BoxShadowLayout className={styles.sources}>
      <p className={styles.sources__title}>{t("Social Sources")}</p>

      {socialSources && (
        <>
          <div className={styles.sources__products}>
            <p>{t("Total Products Shared")}</p>
            <p className={styles["sources__products--amount"]}>
              {socialSources.totalCount.toLocaleString("en-US")}
            </p>
          </div>
          <div className={styles.sources__socials}>
            <SocialItem
              social={SharingSocials.WhatsApp}
              title="WhatsApp"
              amount={socialSources.sharedViaWhatsApp}
            />
            <SocialItem
              social={SharingSocials.Facebook}
              title="Facebook"
              amount={socialSources.sharedViaFacebook}
            />
            <SocialItem
              social={SharingSocials.Instagram}
              title="Instagram"
              amount={socialSources.sharedViaInstagram}
            />
            <SocialItem
              social={SharingSocials.TikTok}
              title="TikTok"
              amount={socialSources.sharedViaTikTok}
            />
            <SocialItem
              social={SharingSocials.Snapchat}
              title="Snapchat"
              amount={socialSources.sharedViaSnapchat}
            />
            <SocialItem
              social={null}
              title="Other"
              amount={socialSources.sharedViaAnotherSocialMedia}
            />
          </div>
        </>
      )}
    </BoxShadowLayout>
  );
};

export default SocialSources;
